var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(_vm._s(_vm._f("arrotonda")(_vm._.get(_vm.trItem.stock, 'costo', '0')))+" €")])}
var staticRenderFns = []

export { render, staticRenderFns }